export default function Racing(props) {
  return (
    <svg
      id="Component_31_27"
      data-name="Component 31 – 27"
      xmlns="http://www.w3.org/2000/svg"
      width="23.546"
      height="20"
      viewBox="0 0 23.546 20"
      {...props}>
      <path
        id="Path_5794"
        data-name="Path 5794"
        d="M704.563-154.476a2.892,2.892,0,0,0-2.736-1.176,6.711,6.711,0,0,1-2.018-.028c-.311-.058-.549-.5-.821-.772.276-.231.527-.608.834-.661a13.014,13.014,0,0,1,2.052-.031,10.222,10.222,0,0,1-.47-10.837h-3.6c-.575,0-1.208-.006-1.186-.78.02-.693.605-.729,1.159-.724a17.87,17.87,0,0,1,2.667.026c1.765.286,2.93-.566,4.074-1.9-1.065,0-2.031.006-3,0a2.2,2.2,0,0,1-.9-.089c-.232-.114-.522-.435-.5-.641.022-.26.309-.517.526-.732.086-.085.292-.071.443-.07,3.285.018,6.578-.1,9.852.095a9.869,9.869,0,0,1,9.227,9.924,9.822,9.822,0,0,1-9.22,9.831c-4.41.221-8.839.1-13.259.075a1.239,1.239,0,0,1-.947-.706c-.121-.607.417-.8.962-.8,1.9-.005,3.807,0,5.711,0Zm-.673-8.44A6.248,6.248,0,0,0,710-156.732a6.276,6.276,0,0,0,6.33-5.96,6.231,6.231,0,0,0-6.151-6.411A6.23,6.23,0,0,0,703.89-162.916Z"
        transform="translate(-696.62 172.915)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5795"
        data-name="Path 5795"
        d="M741.691-147.233a4.884,4.884,0,0,1-1.433,3.979c-.348-.8-.888-1.471-.871-2.126C739.422-146.689,740.345-147.265,741.691-147.233Z"
        transform="translate(-723.533 156.654)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5796"
        data-name="Path 5796"
        d="M721.661-143.945a4.746,4.746,0,0,1-1.211-4.049c.737.411,1.567.61,1.936,1.134C723.128-145.8,722.751-144.773,721.661-143.945Z"
        transform="translate(-711.588 157.135)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5797"
        data-name="Path 5797"
        d="M727.219-137.241c.693-.471.67-1.455,1.7-1.571a2.137,2.137,0,0,1,2.444,1.646A4.55,4.55,0,0,1,727.219-137.241Z"
        transform="translate(-715.876 151.349)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5798"
        data-name="Path 5798"
        d="M721.981-155.848a4.692,4.692,0,0,1,3.407-2.393c-.122.813,0,1.674-.376,2.155C724.241-155.092,723.139-155.008,721.981-155.848Z"
        transform="translate(-712.58 163.627)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5799"
        data-name="Path 5799"
        d="M738.5-155.477a6.7,6.7,0,0,1-2.3.145c-1.237-.419-1.405-1.491-1.07-2.731A4.7,4.7,0,0,1,738.5-155.477Z"
        transform="translate(-720.76 163.515)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5800"
        data-name="Path 5800"
        d="M730.919-146.5a1.066,1.066,0,0,1-.975-1.112,1.1,1.1,0,0,1,1.174-1.118,1.064,1.064,0,0,1,1.082,1.115A1.125,1.125,0,0,1,730.919-146.5Z"
        transform="translate(-717.59 157.614)"
        fill="#f7f7f7"
      />
    </svg>
  );
}
